var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAboutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.3865 2.9165C4.279 2.9165 2.9165 4.36067 2.9165 6.5965V13.4032C2.9165 15.639 4.279 17.0832 6.3865 17.0832H13.6098C15.7198 17.0832 17.0832 15.639 17.0832 13.4032V6.5965C17.0832 4.36067 15.7198 2.9165 13.6115 2.9165H6.3865ZM13.6098 18.3332H6.3865C3.56317 18.3332 1.6665 16.3515 1.6665 13.4032V6.5965C1.6665 3.64817 3.56317 1.6665 6.3865 1.6665H13.6115C16.4357 1.6665 18.3332 3.64817 18.3332 6.5965V13.4032C18.3332 16.3515 16.4357 18.3332 13.6098 18.3332Z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99463 13.9583C9.64963 13.9583 9.36963 13.6783 9.36963 13.3333V10C9.36963 9.655 9.64963 9.375 9.99463 9.375C10.3396 9.375 10.6196 9.655 10.6196 10V13.3333C10.6196 13.6783 10.3396 13.9583 9.99463 13.9583Z",
    fill: "#ffffff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99912 7.67008C9.53829 7.67008 9.16162 7.29758 9.16162 6.83675C9.16162 6.37592 9.53079 6.00342 9.99079 6.00342H9.99912C10.46 6.00342 10.8325 6.37592 10.8325 6.83675C10.8325 7.29758 10.46 7.67008 9.99912 7.67008Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutIcon);
export default __webpack_public_path__ + "static/media/aboutIcon.39153a62cae0537a34284cd93001be8f.svg";
export { ForwardRef as ReactComponent };